import { GET_APPLICATION_LOGS_REQUESTED } from "../types/types";

export default (queryParams) => ({
    type: GET_APPLICATION_LOGS_REQUESTED,
    payload: {
        queryParams
    }
});